import WithGASetup from '../../../components/WithGASetup';
import AuthContext from '../../../context/AuthContext.js';
import DoctorAppointmentsPage from './DoctorAppointmentsPage.js';

export default WithGASetup(DoctorAppointmentsPage, AuthContext);
